<template>
  <div class="PatientManager">
    <div class="toolBar">
      <p>
        <label>患者姓名：</label>
        <Input v-model="name" placeholder="患者姓名" />
      </p>
      <p>
        <label>医生：</label>
        <Input v-model="doctor" placeholder="医生"/>
      </p>
      <p>
        <label>自定义日期：</label>
        <DatePicker type="date" :options="options3" format="yyyy-MM-dd" @on-change="startTime" placeholder="开始日期" v-model="startDate"></DatePicker>
         —
        <DatePicker type="date" :options="options3" format="yyyy-MM-dd" @on-change="endTime" placeholder="结束日期" v-model="endDate"></DatePicker>
      </p>
      <p>
        <Button type="primary" custom-icon="iconfont icon-sousuo1" @click="search">查询</Button>
        <Button type="primary" custom-icon="iconfont icon-jia" @click="addPatient">新增患者</Button>
        <Button type="primary" :custom-icon="verticalIcon" @click="changeVertical">{{verticalName}}</Button>
      </p>
    </div>
    <div class="mainBox">
       <Table v-show="!isVertical" height="530" :columns="columns1" :data="data1" class="vertical"></Table>
       <div class="Horizontal" v-show="isVertical">
         <Card v-for="(item,index) in data1" v-bind:key="index">
           <div>
             <span class="iconfont icon-guanbi1" @click="delPatient(item.id)"></span>
           </div>
           <div class="mainCard">
             <div class="leftCard">
               <span>
                 <img :src="item.sex==1?manIcon:womenIcon" alt="">
               </span>
               <span>{{item.name}}</span>
             </div>
             <div class="rightCard">
               <ul>
                 <li>病案号：{{item.patientNo}}</li>
                 <li>
                   <span>{{item.age}}{{item.ageUnit}}</span>
                   <span>{{item.mobile}}</span>   
                   </li>
                 <li>登记时间：{{item.createTime}}</li>
                 <li>最近就诊时间：{{item.diagnosisTime}}</li>
                 <li>最近诊断：感冒</li>
               </ul>
             </div>
           </div>
           <div class="btnBox">
             <Button type="text" custom-icon="iconfont icon-xiangqing" @click="patientDetail(item.id)">查看详情</Button>
             <Button type="text" custom-icon="iconfont icon-jia" @click="addCase(item.id)">新建病历</Button>
           </div>
         </Card> 
       </div>
       <div class="pageBox">
         <Page :total="total" :transfer='true' show-elevator show-sizer @on-change="changePage" @on-page-size-change="changePageSize" />
       </div>
    </div>
    <Modal 
        class="infoModal"
        :name="modelName"
        v-model="modal1"
        :title="modelTitle"
        @on-ok="ok"
        @on-cancel="cancel">
        <p><Icon :custom="modeIcon" :color="iconColor"></Icon> {{modelContent}}</p>
    </Modal>
  </div>
</template>

<script>
import {
  delPatient,patientDetail,
  patientList,savePatient
} from "../../../api/patient";
import { tips,replaceT,payType } from "../../../tools";

export default {
  name: 'PatientList',
  data () {
    return {
      //禁用今天之后的日期
      options3:{
        disabledDate (date) {
          return date && date.valueOf() > Date.now();
        }
      },
      delId:0,//删除id
      modelName:'delModal',
      modal1:false,
      modelTitle:'系统提示',
      modeIcon:' iconfont icon-Group-',
      iconColor:'#2778E7',
      modelContent:'',
      manIcon:require('../../../assets/img/man.png'),
      womenIcon:require('../../../assets/img/women.png'),
      total:0,
      pageCurrent:1,
      pageSize: 10,
      name:'',//患者姓名/手机号
      doctor:'',//医生
      startDate:'',
      endDate:'',
      columns1:[
        {
          title: '患者',
          key: 'name',
          align:'center'
        },
        {
          title: '电话',
          key: 'mobile',
          align:'center'
        },
        {
          title: '患者编号',
          key: 'patientNo',
          align:'center'
        },
        
        {   
          title: '性别',
          key: 'sex',
          align:'center',
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
              },
              domProps: {
                innerHTML: params.row.sex==1?'男':'女' 
              },
            })
          }
        },
        {
            title: '年龄',
            key: 'age',
            align:'center'
        },
        {
            title: '年龄单位',
            key: 'ageUnit',
            align:'center'
        },
        {
            title: '医生',
            key: 'doctorName',
            align:'center'
        },
        {
            title: '诊断',
            key: 'diagnosis',
            align:'center'
        },
        {
            title: '就诊日期',
            key: 'diagnosisTime',
            align:'center',
            render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
              },
              domProps: {
                innerHTML: replaceT(params.row.diagnosisTime) 
              },
            })
          }
        },
        {
            title: '应收金额(元)',
            key: 'amount',
            align:'center'
        },
        {
            title: '实收金额(元)',
            key: 'actualAmount',
            align:'center'
        },
        {
          title: '操作',
          align:'center',
          key: 'methods',
          align: 'center',
          minWidth:206,
          render: (h, params) => {
            return h('div',{
              style: {
                  textAlign: 'center'
                }
              },
              [
                h('Button', {
                  props: {
                    // type: 'error',
                    size: 'small',
                    ghost:true,
                    type:'info',
                    customIcon:'iconfont icon-jia'
                  },
                  style: {
                    textAlign:'center',
                    margin:' 0 5px 0',
                    borderColor:'#2778E7',
                    color:'#2778E7'
                  },
                  'class':{

                  },
                  on: {
                    click: () => {
                      let id = params.row.id;
                      this.addCase(id);
                    },
                  }
                }, '新建病历'),
                h('Button', {
                  props: {
                    // type: 'error',
                    size: 'small',
                    ghost:true,
                    type:'info',
                    customIcon:'iconfont icon-order'
                  },
                  style: {
                    textAlign:'center',
                    margin:' 0 5px 0',
                    borderColor:'#c9c9c9',
                    color:'#616882'
                  },
                  'class':{

                  },
                  on: {
                    click: () => {
                      let id = params.row.id;
                      this.patientDetail(id)
                    }
                  }
                }, '查看'),
                
                h('Button', {
                  props: {
                    // type: 'error',
                    size: 'small',
                    ghost:true,
                    type:'info',
                    customIcon:'iconfont icon-shanchu'
                  },
                  style: {
                    textAlign:'center',
                    margin:' 0 5px 0',
                    borderColor:'#c9c9c9',
                    color:'#616882'
                  },
                  'class':{

                  },
                  on: {
                    click: () => {
                      let id = params.row.id;
                      this.modelName = 'del';
                      this.modelTitle = '删除';
                      this.delPatient(id);
                    }
                  }
                }, '删除')
            ]);
          }
        }
      ],
      data1:[],
      isVertical:false,//是否为横版
      verticalName:'横版',
      verticalIcon:'iconfont icon-zhanshi',
    }
  },
  created(){
    let lett = this;
    document.onkeydown = function(e) {
    let key = window.event.keyCode;
    if (key == 13) {
      lett.search();
      }
    }
  },
  mounted(){
    this.loadList();
  },
  methods:{
    loadList(){
      this.search();
    },
    //搜索
    search(){
      let _this = this;
      let params = {
        current: _this.pageCurrent,
        endTimes: _this.endDate,
        name: _this.doctor,
        nameAndPhone: _this.name,
        size: _this.pageSize,
        starTimes: _this.startDate
      };
      patientList(
        params
      ).then(res => {
        console.log(res);
        _this.total = res.total;
        _this.data1 = res.records;
        let arr = [];
        for(let i=0;i<_this.data1.length;i++){
          _this.data1[i].createTime = replaceT(_this.data1[i].createTime);
          _this.data1[i].diagnosisTime = replaceT(_this.data1[i].diagnosisTime);
        }
      });
    },
    //添加患者信息
    addPatient(){

    },
    //新建病历
    addCase(id){
      this.$router.push({path:'cliniclist',query:{patientId:id}});
    },
    //跳转患者详情页
    patientDetail(id){
      this.$router.push({path:'patientdetail',query:{id:id}})
      
    },
    //删除患者弹框
    delPatient(id){
      this.delId = id;
      this.modal1 = true;
      this.modelContent = '请确认，删除该患者后，相关病例及就诊信息将被删除！';

    },
    //改变横版还是竖版
    changeVertical(){
      console.log(this.verticalName);
      console.log(this.isVertical);
      this.isVertical = !this.isVertical;
      switch(this.isVertical){
        //横版
        case true:
          this.verticalIcon = 'iconfont icon-liebiao';
          this.verticalName = '竖版';
          break;
        case false:
          this.verticalIcon = 'iconfont icon-zhanshi';
          this.verticalName = '横版';
          break;
      }
    },
    //改变页码
    changePage(current){
      this.pageCurrent = current;
      this.loadList();
    },
    //改变每页条数
    changePageSize(size){
      this.pageSize = size;
      this.loadList();
    },
    ok(){
      let _this = this;
      delPatient({
        id:_this.delId
      }).then(res => {
        console.log(res)
        tips(this,res,'success');
        _this.loadList();
      });
    },
    cancel(){

    },
    startTime(e){
      this.startDate = e;
      console.log(e)
    },
    endTime(e){
      this.endDate = e;
      console.log(e)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
.PatientManager .toolBar{
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-flow: wrap ;
  padding: 10px 0;
  border-bottom: 1px solid #c9c9c9;
}
.PatientManager .toolBar>p{
  padding: 5px 0;
  margin-right: 20px;
}
.PatientManager .toolBar>p>label{
  display: inline-block;
}
.PatientManager .toolBar>p>button{
  margin-right: 10px;
}
.mainBox{
  margin-top: 15px;
}
.pageBox{
  text-align: center;
  padding: 5px 0;
  margin-top: 10px;
}
.ivu-input-wrapper{
  width: 120px;
}
.ivu-select{
  width: 120px;
  /* width: 100%; */
}
.ivu-date-picker{
  width: 120px;
}

.Horizontal{
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-flow: row wrap;
}
.Horizontal /deep/ .ivu-card{
  width: 32%;
  margin:0 10px 20px 0;
}
.Horizontal /deep/ .ivu-card-body{
  padding: 5px 0 0 0;
}
.Horizontal .ivu-card-body>div:first-child{
  height: 24px;
  padding: 0 10px;
}
.Horizontal .ivu-card-body>div:first-child>span{
  float: right;
  cursor: pointer;
  width: 20px;
  height: 20px;
  line-height: 20px;
  border-radius:50%; 
  text-align: center;
  font-size: 16px;
}
.Horizontal .ivu-card-body>div:first-child>span:hover{
  color: #fff;
  background-color: #2778E7;
}
.Horizontal .mainCard{
  display: flex;
  justify-content: space-between;
  margin: 0;
  padding: 0 10px 10px;
}
.Horizontal .mainCard>.leftCard{
  width: 35%;
}
.Horizontal .mainCard>.leftCard>span:first-child{
  height: 70%;
  display: block;
  text-align: center;
}
.Horizontal .mainCard>.leftCard>span{
  display: inline-block;
  text-align: center;
  width: 100%;
}
.Horizontal .mainCard>.leftCard>span>img{
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}
.Horizontal .mainCard>.rightCard{
  width: 64%;
}
.Horizontal .btnBox{
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #c9c9c9;
}
.Horizontal .btnBox>button{
  width: 50%;
  color: #2778E7;
}
.Horizontal .btnBox>.ivu-btn{
  border-radius: 0;
}
.Horizontal .btnBox>button:first-child{
  border-right: 1px solid #c9c9c9;
}
</style>



// WEBPACK FOOTER //
// src/views/clinic/patientlist/PatientList.vue